module.exports = __webpack_public_path__ + "img/badge-member-darkbg.c6b619bd.svg";